export const backgrounds = {
    "_": "/images/backgrounds",
    "__": "/images/backgrounds/thumbnails",
    "bg": [
        "17xh-404Room.png",
        "17xh-ButterflyFactory.png",
        "17xh-Networld.png",
        "17xh-ShootingRange.png",
        "19winter_aurora.png",
        "19winter_biggun.png",
        "19winter_doorexplode.png",
        "19winter_inbg_2.png",
        "19winter_ump45vs.png",
        "2018SummerCG6-1.png",
        "2018SummerCG8.png",
        "2018Winter1-1.png",
        "2018Winter7-1.png",
        "2019summer_1.png",
        "2019summer_10.png",
        "2019summer_11.png",
        "2019summer_12.png",
        "2019summer_13.png",
        "2019summer_14.png",
        "2019summer_3.png",
        "2019summer_4_1.png",
        "2019summer_4_2.png",
        "2019summer_5.png",
        "2019summer_6.png",
        "2019summer_7.png",
        "2019summer_8.png",
        "2019summer_9.png",
        "2020summerFlowerfield.png",
        "2021white_Bernvillage.png",
        "BG-Bar.png",
        "BG-BarHallow.png",
        "BG-BarSpring.png",
        "BG-BarXmas.png",
        "BG-Beach.png",
        "BG-BeachNight.png",
        "BG-BurnCity.png",
        "BG-ContaminatedZone.png",
        "BG-Corridor.png",
        "BG-Cybercity.png",
        "BG-DinnerNoMan.png",
        "BG-DjmaxCemetery.png",
        "BG-DjmaxCity.png",
        "BG-DjmaxGraveyard.png",
        "BG-Dorm.png",
        "BG-Fortress.png",
        "BG-Grass.png",
        "BG-GrassWedding.png",
        "BG-Guildhall.png",
        "BG-InterrogationRoom.png",
        "BG-Kitchen.png",
        "BG-Monument.png",
        "BG-Mullet.png",
        "BG-RuinedCity.png",
        "BG-Sanatorium.png",
        "BG-Sewer.png",
        "BG-Slum.png",
        "BG-TemporaryBase.png",
        "BG-Theatre.png",
        "BG-Wall.png",
        "BG-WarehouseOFF.png",
        "BG-WarehouseON.png",
        "BG-Wedding.png",
        "BG-WildBattle.png",
        "BG9-Dinner.png",
        "BGDefult_fixed.png",
        "BG_Base.png",
        "BG_City.png",
        "BG_Inner.png",
        "BG_Street.png",
        "CG4N.png",
        "Metro.png",
        "Va11_BAR.png",
        "cg-2018-Autumn-moon_fixed.png",
        "cg-halloween2018_fixed.png",
        "cg4_fixed.png",
        "cg_2018newyear_fixed.png",
        "cg_2019_redmoon_fixed.png",
        "cg_Xmas18_fixed.png",
        "cg_christmas_bed_fixed.png",
        "cg_christmas_room_fixed.png",
        "主界面背景.png",
        "冰湖.png",
        "大桥.png",
        "机场.png",
        "树林.png",
        "街道.png",
        "雪地.png"
    ]
}